@import '../../../../constants/spacing.module.less';

.setup-complete-banner-wrapper {
  margin-bottom: @space-16;
}

.setup-complete-banner {
  border-radius: @space-8;
}
